<template>
    <div>
        <button type="submit" class="block w-full px-4 py-2 text-sm leading-5 text-purple-dark-900 text-left hover:bg-blue-dark-700 hover:text-white focus:text-white focus:outline-none focus:bg-blue-dark-700 transition" v-if="as == 'button'">
            <slot></slot>
        </button>

        <a :href="href" class="block px-4 py-2 text-sm leading-5 text-purple-dark-900 hover:bg-blue-dark-700 hover:text-white focus:text-white focus:outline-none focus:bg-blue-dark-700 transition" v-else-if="as =='a'">
            <slot></slot>
        </a>

        <Link :href="href" class="hover:text-white focus:text-white block px-4 py-2 text-sm leading-5 text-purple-dark-900 hover:bg-blue-dark-700 hover:text-white focus:text-white focus:outline-none focus:bg-blue-dark-700 transition" v-else>
            <slot></slot>
        </Link>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },
    props: ['href', 'as']
}
</script>
